import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '@components/common/Button';
import { ensureGuestIdentity } from '@services/guestIdentity';
import { hasAuthToken } from '@utils/cookie';
import { theme } from '@styles/theme';
import { ConsultationChat } from './ConsultationChat';
import { ConsultationDialog } from './ConsultationDialog';

const Launcher = styled.button<{ $checkout: boolean }>`position: fixed; right: max(20px, env(safe-area-inset-right)); bottom: calc(${p => p.$checkout ? '100px' : '24px'} + env(safe-area-inset-bottom)); z-index: ${theme.zIndex.fixed}; border: none; border-radius: 28px; padding: 14px 20px; min-height: 48px; background: ${theme.colors.primary}; color: white; box-shadow: ${theme.shadows.lg}; font: inherit; cursor: pointer; &:focus-visible { outline: 3px solid ${theme.colors.text.primary}; outline-offset: 3px; }`;
export function ConsultationWidget({ authEpoch }: { authEpoch: number }) {
  const { t } = useTranslation('consultation');
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [initializing, setInitializing] = useState(false);
  const [identityError, setIdentityError] = useState(false);
  const initialize = async () => {
    setInitializing(true); setIdentityError(false);
    try { await ensureGuestIdentity(); } catch { setIdentityError(true); } finally { setInitializing(false); }
  };
  return <>
    <Launcher $checkout={location.pathname === '/checkout'} aria-label={t('title')} aria-expanded={open} onClick={() => { setOpen(true); if (!hasAuthToken()) void initialize(); }}>✉ {t('title')}</Launcher>
    {/* Keep this subtree while closed so the current identity's draft survives, but stop all requests. */}
    <ConsultationDialog isOpen={open} title={t('title')} onClose={() => setOpen(false)}>
      {hasAuthToken() ? <ConsultationChat key={authEpoch} scope={{ authEpoch }} active={open} /> : <p>{t(identityError ? 'identityFailed' : 'initializing')} <Button disabled={initializing} onClick={() => void initialize()}>{t('retry')}</Button></p>}
    </ConsultationDialog>
  </>;
}
